"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _vuex = require("vuex");

var _setInterval = _interopRequireDefault(require("set-interval"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = {
  data: function data() {
    return {
      showPanel: false
    };
  },
  computed: _objectSpread({}, (0, _vuex.mapGetters)(['notifications', 'user'])),
  created: function created() {
    if (this.user && this.user.id > 0) {
      this.$store.dispatch('notifications/read', this.user.id);
    }
  },
  beforeMount: function beforeMount() {
    var _this = this;

    this.$store.dispatch('notifications/read', this.user.id).then(function (notifications) {
      _this.noticeNewNotifs(notifications);
    });
  },
  mounted: function mounted() {
    var _this2 = this;

    if (this.user && this.user.id > 0) {
      _setInterval.default.start(function () {
        _this2.$store.dispatch('notifications/read', _this2.user.id).then(function (notifications) {
          _this2.noticeNewNotifs(notifications);
        });
      }, 60000, 'NOTIFIER'); // 60000 = 60s * 1000ms = every minutes

    }
  },
  beforeDestroy: function beforeDestroy() {
    _setInterval.default.clear('NOTIFIER');
  },
  methods: {
    unreadNotification: function unreadNotification() {
      return this.notifications.notifications.filter(function (x) {
        return x.date_markasread === null;
      });
    },
    onMenuCommand: function onMenuCommand(command) {
      switch (command) {
        case 'markAllAsRead':
          this.$store.dispatch('notifications/markallasread', this.user.id);
          break;

        case 'seeAllNotifications':
          this.$router.push('/notification');
          break;
      }
    },
    onClosePanel: function onClosePanel(done) {
      done();
    },
    onCloseAlert: function onCloseAlert(notification) {
      this.$store.dispatch('notifications/markasread', notification);
    },
    noticeNewNotifs: function noticeNewNotifs(notifications) {
      var _this3 = this;

      var newNotifs = notifications.filter(function (x) {
        return x.date_notification === null && x.date_markasread === null;
      });

      if (newNotifs.length > 0) {
        newNotifs.forEach(function (x) {
          _this3.$store.dispatch('notifications/markasnotified', x);
        });
      }
    }
  }
};
exports.default = _default;